import { Button } from "@mui/material";
import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import Swal from "sweetalert2";
import axios from "axios";
import { Spin } from "antd";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import sampleIcon from "../../Assets/Images/info.png";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeading from "../../Components/PageHeading/PageHeading";
import { IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import SamplePdfModal from "../../Components/SamplePdfModal/SamplePdfModal";
import ContentVoice from "../Gallery/ContentVoice";
import AiContentAudit from "../../Components/AiContentAudit/AiContentAudit";
import AiFactsDisplay from "../../Components/AiFacts/AiFactsDisplay";

const voiceExamples = [
  "Welcome to our podcast! Today we'll explore the fascinating world of artificial intelligence.",
  "In a world where technology meets creativity, innovation knows no bounds.",
  "Good morning! This is your daily briefing on the latest tech news and trends.",
  "Imagine a future where robots and humans work together seamlessly.",
  "Let me tell you a story about a curious mind that changed the world forever."
];

const VoiceAi = () => {
  const { AIuser, userRefetch, setUserRefetch } = useContext(UserAuthContext);
  const randomIndex = Math.floor(Math.random() * voiceExamples.length);
  const [exampleText, setExampleText] = useState(voiceExamples[randomIndex]);
  const [scriptText, setScriptText] = useState("");
  const [generatedAudio, setGeneratedAudio] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [voiceType, setVoiceType] = useState("sage");
  const [wordCount, setWordCount] = useState(0);
  const [creditsNeeded, setCreditsNeeded] = useState(0);
  const [attributionPage, setAttributionPage] = useState(true);
  const [auditChecked, setAuditChecked] = useState(false);
  const navigate = useNavigate();
  const audioRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Word count function
  const countWords = (text) => {
    if (!text || text.trim().length === 0) return 0;
    return text.trim().split(/\s+/).filter(word => word.length > 0).length;
  };

  // Update word count and credits needed when script changes
  useEffect(() => {
    const words = countWords(scriptText);
    setWordCount(words);
    setCreditsNeeded(Math.ceil(words / 3000));
  }, [scriptText]);

  const creditTolcalString = AIuser?.credits
    ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
    : "0";

  // const handleSubmitCredits = async (creditsToDeduct) => {
  //   const deductedCredits = AIuser.credits - creditsToDeduct;

  //   await axios
  //     .put(
  //       "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
  //       { email: AIuser?.email, credits: deductedCredits },
  //       {
  //         headers: {
  //           authorization: `Bearer ${localStorage.getItem("aiUser")}`,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setUserRefetch(!userRefetch);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const handleGenerateClick = () => {
    // Check if user has enough credits
    if (AIuser.credits < creditsNeeded) {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",
        icon: "error",
        buttons: "Buy",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/purchase");
        }
      });
      return;
    }

    // Show confirmation popup with word count and credits
    Swal.fire({
      title: "Generate Voice AI",
      html: `
        <div style="text-align: center; padding: 10px;">
          <p style="margin: 10px 0;"><strong>Words in script:</strong> ${wordCount}</p>
          <p style="margin: 10px 0;"><strong>Credits required:</strong> ${creditsNeeded}</p>
          <p style="margin: 10px 0;"><strong>Your current balance:</strong> ${Math.floor(AIuser.credits)}</p>
          <p style="margin: 10px 0;"><strong>Balance after generation:</strong> ${Math.floor(AIuser.credits - creditsNeeded)}</p>
        </div>
      `,
      icon: "info",
      background: "#001f3f",
      color: "#ffffff",
      showCancelButton: true,
      confirmButtonText: "Generate",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    }).then((result) => {
      if (result.isConfirmed) {
        generateVoice();
      }
    });
  };

  const generateVoice = async () => {
    const randomChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz01234567891011121314156655";
    let transactionId = "";
    for (let i = 0; i < 8; i++) {
      transactionId += randomChars.charAt(
        Math.floor(Math.random() * randomChars.length)
      );
    }

    setGeneratedAudio(null);
    setIsLoading(true);
    setIsLoaded(true);
    const body = {
      script: scriptText,
      voiceType: voiceType,
      attributionPage
    }

    await axios
      .post(
        "https://backend.whalesai.com/api/v1/chatgpt/voiceai",
        body,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("aiUser")}`,
          },
        }
      )
      .then(async (res) => {
        if (res.status === 200) {
          setGeneratedAudio(res?.data?.audioUrl);
          // handleSubmitCredits(creditsNeeded);
          setUserRefetch(!userRefetch)
          await axios.post(
            "https://backend.whalesai.com/api/v1/credits-transaction/create",
            {
              aiType: "Voice Ai",
              transactionId: transactionId,
              requestQues: scriptText,
              response: res?.data?.audioUrl,
              credit: creditsNeeded,
              userId: AIuser?._id,
            }
          );
          setIsLoaded(false);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoaded(false);
        setIsLoading(false);
        swal({
          text: "Something went wrong! Please try again.",
          icon: "error",
          buttons: "Ok",
          className: "modal_class_success",
        });
      });
  };

  const downloadAudio = async () => {
    try {
      setDownloading(true);
      const response = await fetch(generatedAudio);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const fileName = `voiceai_${Date.now()}.mp3`;
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setDownloading(false);
    } catch (error) {
      console.error("Error downloading audio:", error);
      setDownloading(false);
      swal({
        text: "Error downloading audio file. Please try again.",
        icon: "error",
        buttons: "Ok",
        className: "modal_class_success",
      });
    }
  };

  const refreshExample = () => {
    const newRandomIndex = Math.floor(Math.random() * voiceExamples.length);
    if (exampleText !== voiceExamples[newRandomIndex]) {
      setExampleText(voiceExamples[newRandomIndex]);
    } else {
      setExampleText(
        voiceExamples[(newRandomIndex + 1) % voiceExamples.length]
      );
    }
  };

  const creditToLocalString = AIuser?.credits ? parseInt(Math.floor(AIuser?.credits)).toLocaleString() : "0";

  return (
    <Fragment>
      {/* <PageHeading
        title={"VOICE AI"}
        description={
          "Voice AI turns text into natural, emotional voiceovers."
        }
        onInfoClick={() => setShowPdfModal(true)}
        infoTooltip="See sample voice"
      /> */}
      <SamplePdfModal pdfModal={showPdfModal} setPdfModal={setShowPdfModal} title="What you can do?">
        <ContentVoice />
      </SamplePdfModal>
      <div className="container pb-5">
        <div
          style={{
            maxWidth: "872px",
            paddingInline: "12px",
            marginInline: "auto",
          }}
          className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2"
        >
          <div className="">
            {/* <div className="">
              <button className="credits-button">
                CREDITS : {creditTolcalString}
              </button>
              <button
                className="buy-credits-button"
                onClick={() => navigate("/purchase")}
              >
                BUY CREDITS
              </button>

              <button
                onClick={() => navigate("/usage")}
                className="money-exchange-button"
              >
                <img src={moneyExchangeIcon} alt="moneyExchangeIcon" />
              </button>
            </div> */}

            <p className="all-page-title all-page-gradient-text text-center my-4">VOICE AI</p>

            <div className="credits-actions">

              <button className="credits-button">
                CREDITS : {creditToLocalString}
              </button>

              <button
                className="buy-credits-button"
                onClick={() => navigate("/purchase")}
              >
                BUY CREDITS
              </button>

              <button
                onClick={() => navigate("/usage")}
                className="money-exchange-button"
              >
                <img src={moneyExchangeIcon} alt="usage" />
              </button>

              <button
                type="button"
                className="money-exchange-button"
                onClick={() => {
                  setShowPdfModal(true);
                }}

              >
                <img src={sampleIcon} alt="See sample video" />
              </button>

            </div>
            <p
              style={{ fontSize: "8px" }}
              className="text-white mt-2 creditText text-center"
            >
              1 Credit per 3000 characters (USD 0.012 based on Credits Package 3)
            </p>
          </div>
        </div>
        <div
          style={{
            maxWidth: "872px",
            paddingInline: "12px",
            marginInline: "auto",
          }}
          className="pt-3 "
        >
          <div>
            <div className="text-center mb-3">
              <p style={{ color: "white" }}>
                Write or paste your custom script below.
              </p>
              <p
                onClick={() => setScriptText(exampleText)}
                style={{ cursor: "pointer" }}
                className="text-warning my-3 text-center"
              >
                <span className="text-danger">Example:</span> {exampleText}
              </p>
              <img
                onClick={refreshExample}
                style={{ cursor: "pointer" }}
                src={require("../../Assets/Images/relaoder.png")}
                alt="reload"
                width="30"
                height="30"
              />
            </div>
            <div className="d-flex flex-column-reverse flex-md-row align-items-center align-items-md-start gap-2 position-relative">
              <span
                className="text-danger"
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "15px",
                  zIndex: 10
                }}
              >
                *
              </span>
              <textarea
                onChange={(e) => setScriptText(e.target.value)}
                className="p-2 px-3 mb-2 w-100 text-white"
                style={{
                  background: "#011C34",
                  border: "2px solid #FFF",
                  borderRadius: "12px",
                  outline: "none",
                  height: "150px",
                  resize: "none",
                }}
                value={scriptText}
                placeholder="Enter your script here..."
                rows="6"
              />
            </div>

            {/* Voice Type Selection */}
            <div className="mb-3">
              <label
                className="text-white mb-2 d-block text-start"
                style={{ fontSize: "14px" }}
              >
                Select Voice Type
              </label>
              <select
                value={voiceType}
                onChange={(e) => setVoiceType(e.target.value)}
                className="w-100 p-2 px-3 text-white"
                style={{
                  background: "#011C34",
                  border: "2px solid #FFF",
                  borderRadius: "12px",
                  outline: "none",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                <option value="sage">Sage - Female, Soft, soothing, and narrative</option>
                <option value="nova">Nova - Female, Calm, measured and highly professional</option>
                <option value="echo">Echo - Male, Tech-oriented, robotic, yet smooth</option>
                <option value="onyx">Onyx - Male, Deep, authoritative and direct</option>
              </select>
            </div>

            {scriptText && (
              <div className="text-center mb-3">
                <p className="text-white mb-1">
                  <strong>Word Count:</strong> {wordCount} words
                </p>
                <p className="text-warning mb-0">
                  <strong>Credits Required:</strong> {creditsNeeded} {creditsNeeded !== 1 ? 'credits' : 'credit'}
                </p>
              </div>
            )}

            <p className="pt-1 pb-2 text-white mb-0 text-center">
              The Voice AI automatically produces natural, emotionally rich voice output based on the tone and context of your text input.
            </p>

            <div
              className="d-flex align-items-center justify-content-center text-center mt-4"
            >
              <input
                type="checkbox"
                id="attributionCheckboxInline"
                style={{ marginRight: '8px' }}
                checked={attributionPage}
                onChange={(e) => setAttributionPage(e.target.checked)}
              />
              <label htmlFor="attributionCheckboxInline" className="text-white" style={{ fontSize: '14px', cursor: 'pointer' }}>
                The Attribution
              </label>
            </div>

            {/* <AiContentAudit checked={auditChecked} onChange={setAuditChecked} />c */}

            <div className="d-flex justify-content-center align-items-center">
              <Button
                sx={{
                  padding: "8px 30px",
                  marginRight: "10px",
                  color: "#000",
                  background: "#fff",
                  "&:hover": { background: "#fff" },
                  "&:disabled": { background: "#fff" },
                }}
                onClick={() => setScriptText("")}
                disabled={!scriptText}
                variant="contained"
              >
                Clear
              </Button>
              <Button
                sx={{
                  padding: "8px 30px",
                  margin: "15px 0px",
                  "&:disabled": { background: "gray" },
                }}
                onClick={handleGenerateClick}
                className={`generate-button text-white `}
                disabled={!scriptText || isLoaded}
                variant="contained"
              >
                {isLoaded ? "Processing..." : "Generate"}
              </Button>
            </div>

            <div className="animate text-md-center mt-4 text-lg-center text-center mb-5 d-flex justify-content-center force-small-font">
              Please do not navigate away from the browser.
              <br /> Doing so will stop the process.
            </div>
            <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
              While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
            </div>
            <p className="mb-5"></p>
          </div>
          {isLoaded && (
            <div className="text-center mb-3">
              <Spin size="large" className="pt-5 pb-2 " />
              <p className="text-center pb-2 d-block text-white mb-0">
                Generating your voiceover... Please wait.
              </p>
            </div>
          )}
          {/* Interesting facts while generating */}
          {isLoaded && <AiFactsDisplay />}
          {generatedAudio && !isLoading && (
            <div className="text-center mb-5">
              <h5 className="text-white mb-3">Your Voiceover is Ready!</h5>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >
                <audio
                  ref={audioRef}
                  controls
                  src={generatedAudio}
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    borderRadius: "8px",
                  }}
                >
                  Your browser does not support the audio element.
                </audio>
              </div>
              <Button
                sx={{
                  padding: "8px 30px",
                  margin: "15px auto",
                  display: "block",
                  background: "#2e7d32!important",
                  color: "white!important",
                }}
                variant="contained"
                onClick={downloadAudio}
                disabled={downloading}
              >
                {downloading ? "Downloading..." : "Download Audio"}
              </Button>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default VoiceAi;

